import { defineMessage } from 'services/localization';

export const messages = {
    companySelectTitle: defineMessage('organisation'),
    templateSelectTitle: defineMessage('type_1'),
    cancelButtonTitle: defineMessage('cancel'),
    saveButtonTitle: defineMessage('save'),
};
